<template>
  <div class="data-table-detail-row">
    <div class="metadata">
      <loader :show="$apollo.loading" message="Loading..." />
      <div class="scenario">
        <span class="title-span">Scenario: </span
        >{{ this.recording && this.recording.scenario }}
      </div>
      <div class="quality">
        <span class="title-span">Quality: </span
        >{{ this.recording && this.recording.quality }}
      </div>
      <div class="position_aiding">
        <span class="title-span">Position Aiding: </span>
        {{ this.recording && this.recording.positionaiding }}
      </div>
    </div>
    <span class="title-span">Exports:</span>
    <data-table
      :fields="options.fields"
      :actions-popup="true"
      :actions="options.actions"
      :action-filter="options.actionFilter"
      :per-page="perPage"
      :total-items="totalItems"
      :manual-pagination="true"
      :current-page="currentPage"
      :show-heading="false"
      :show-export="false"
      :show-tags="false"
      :data="exportData"
      @onRowDblClicked="onRowDblClicked"
      @onCellClicked="onCellClicked"
      @onChangePage="onChangePage"
    ></data-table>
  </div>
</template>

<script lang="ts">
import { Recording } from "@/motion-cloud";
import { QUERY_RECORDING } from "@/graphql/files";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "FolderDetailRow",
  apollo: {
    recording: {
      query: QUERY_RECORDING,
      fetchPolicy: "no-cache",
      variables() {
        return {
          id: this.rowData.uuid,
          limit: 5,
          page: this.currentPage
        };
      }
    }
  }
})
export default class FolderDetailRow extends Vue {
  @Prop({ required: true })
  rowData!: Record<string, any>;

  @Prop()
  rowIndex!: number;

  @Prop()
  options!: Record<string, any>;

  currentPage = 1;

  recording!: Recording;

  get exportData() {
    return this.recording?.exports?.items ?? [];
  }

  get detailData() {
    return this.rowData[this.options.dataField];
  }

  get perPage() {
    return this.options.perPage ?? 5;
  }

  get totalItems() {
    return this.recording?.exports.meta.totalItems ?? 0;
  }

  onCellClicked({ data, field }: { data: any; field: string }) {
    this.$emit("onDetailRowCellClicked", { data, field });
  }

  onRowDblClicked(data: any) {
    this.$emit("onDetailRowDblClicked", data.data);
  }

  async onChangePage(page: number) {
    const paginatedData = await this.$apollo.query({
      query: QUERY_RECORDING,
      fetchPolicy: "no-cache",
      variables: {
        id: this.rowData.uuid,
        limit: 5,
        page: page
      }
    });
    this.recording.exports.items =
      paginatedData?.data?.recording?.exports?.items;
    this.currentPage = page;
  }
}
</script>

<style lang="scss" scoped>
.data-table-detail-row {
  padding: 12px;
  letter-spacing: 0;
  line-height: 24px;

  .title-span {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
  }

  .title {
    color: $primary;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 24px;
  }

  th {
    font-weight: bold;
    padding: 12px 12px 0 12px;
  }

  td {
    padding: 12px;
  }
}
</style>
